import { Component, OnInit } from '@angular/core';



@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    
    
    
  }


}



// WEBPACK FOOTER //
// D:/TPL ILG/3PL_ILG/src/app/components/home/home.component.ts